import { environment } from "../../environments/environment";

/** Relative path under the landing origin (must be absolute URL in meta tags). */
export const LANDING_SEO_OG_IMAGE_PATH =
  "/assets/images/landing-1/thumbnail.png";

export const LANDING_SEO_OG_IMAGE_WIDTH = 1424;
export const LANDING_SEO_OG_IMAGE_HEIGHT = 449;

export const LANDING_SEO_LOGO_PATH =
  "/assets/images/logos/logos-demo/logo-large-ligth-landing.png";

export const LANDING_SEO_THEME_COLOR = "#2e7d32";

export const LANDING_SEO_SUPPORTED_LANGUAGES = ["en", "es"] as const;

export type LandingSeoLanguage = (typeof LANDING_SEO_SUPPORTED_LANGUAGES)[number];

export function landingSeoAbsoluteUrl(path: string = "/"): string {
  const base = environment.landingSiteUrl.replace(/\/$/, "");
  if (!path || path === "/") {
    return `${base}/`;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}

export function landingSeoOgImageUrl(): string {
  return landingSeoAbsoluteUrl(LANDING_SEO_OG_IMAGE_PATH);
}

export function landingSeoLogoUrl(): string {
  return landingSeoAbsoluteUrl(LANDING_SEO_LOGO_PATH);
}
